import { NextRequest, NextResponse, userAgent } from 'next/server';

type ABTest = { name: string; paths: string[] };

// Define an array of A/B tests with their respective paths where "name" will be name of the abtest cookie
// define the paths in correct variant order. [original, variant_1, variant_2, ...] for correct name assignment.
export const AB_TESTS: ABTest[] = [
	// You can add more A/B tests here as needed
	{ name: 'faktureringsprogram', paths: ['/produkt/faktureringsprogram', '/produkt/faktureringsprogram/2'] },
	{ name: 'bokforingsprogram', paths: ['/produkt/bokforingsprogram', '/produkt/bokforingsprogram/2'] },
];

const getRandomizedVariant = (paths: string[]) => {
	const randomIndex = Math.floor(Math.random() * paths.length);
	const randomPath = paths[randomIndex];
	return {
		variant: paths[0] ? 'original' : `variant_${randomIndex}`,
		path: randomPath,
	};
};

export async function middleware(request: NextRequest) {
	const { isBot } = userAgent(request);
	const preview = request.cookies.get('__next_preview_data');
	const url = request.nextUrl.clone();
	const enabled = isBot === false && !preview;
	let variantCookie;
	let variant: { variant: string; path: string } | null = null;

	AB_TESTS.forEach((test) => {
		if (enabled && test.paths.some((path) => request.nextUrl.pathname === path)) {
			variantCookie = request?.cookies?.get(`ab_test_${test.name}`);

			if (variantCookie) {
				const oldFormat = variantCookie.value.indexOf('-') !== -1;
				const index = oldFormat ? variantCookie.value.split('-')[1] : variantCookie.value.split('_')[1];

				variant = {
					path: variantCookie.value === 'original' ? test.paths[0] : test.paths[Number(index)],
					variant: variantCookie.value,
				};
			} else {
				variant = getRandomizedVariant(test.paths);
			}

			url.pathname = variant.path;
		}
	});

	const response = NextResponse.rewrite(url);

	return response;
}

export const config = {
	// Define paths where the middleware should be applied (copy the paths: [] from above)
	matcher: [
		'/produkt/faktureringsprogram',
		'/produkt/faktureringsprogram/2',
		'/produkt/bokforingsprogram',
		'/produkt/bokforingsprogram/2',
	],
};
